import { render, staticRenderFns } from "./choosestaff.vue?vue&type=template&id=8b9cfd8a&scoped=true"
import script from "./choosestaff.vue?vue&type=script&lang=js"
export * from "./choosestaff.vue?vue&type=script&lang=js"
import style0 from "./choosestaff.vue?vue&type=style&index=0&id=8b9cfd8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9cfd8a",
  null
  
)

export default component.exports